<template>
  <div class="paymentStatus-Main">
    <h1>Payment Status</h1>
    <div class="paymentStatus-Box">
      <p>Record ID : {{paymentId}}</p>
      <p>Status : {{status}}</p>
      <p>Amount(MYR) : {{amount}}</p>
      <p>Payment Date : {{paydate}}</p>
      <p>Payment Type : {{paytype}}</p>
      <p>Invoice No : {{invoiceno}}</p>
      <p>Total Amount(MYR) : {{invoicetotal}}</p>
      <p>Total Paid Amount(MYR) : {{invoicepaidamount}}</p>
      <p>Invoice Status: {{invoicestatus}}</p>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
export default {
  data: function() {
    return {
      paymentId: '',
      status: '',
      amount:'',
      paydate: '',
      paytype: '',
      invoiceno: '',
      invoicetotal: '',
      invoicepaidamount: '',
      invoicestatus: ''
    }
  },
  methods: {
    paymentStatusCallAPI: async function() {
      //call payment response api //will call requery api. then return requery records. 
      console.log(this.paymentId);
      console.log(this.paymentId);
      
      let details = await this.$apiCallV2(`/PaymentStatus/getPaymentResponse?paymentId=${this.paymentId}`);
      this.status = details['status'] ? details['status'] : '';
      this.amount = details['amount'] ? details['amount'] : '';
      this.invoiceno = details['invoiceno'] ? details['invoiceno'] : '';
      this.paydate = details['paydate'] ? details['paydate'] : '';
      this.paytype = details['paytype'] ? details['paytype'] : '';
      this.invoicetotal = details['invoicetotal'] ? details['invoicetotal'] : '';
      this.invoicepaidamount = details['invoicepaidamount'] ? details['invoicepaidamount'] : '';
      this.invoicestatus = details['invoicestatus'] ? details['invoicestatus'] : '';
      console.log(details);
    }
  },
  async mounted() {
    // let params = this.$route.params;
    let query = this.$route.query;
    if (query['paymentId']) {
      this.paymentId = query['paymentId'];
      await this.$nextTick();
      this.$fullscreenLoading(`Getting ${this.paymentId} Status`);
      await this.paymentStatusCallAPI();
      this.$fullscreenLoading();
    }
  }
}
</script>

<style lang="scss" scoped>
.paymentStatus-Main {
  padding: 10px;
  > .paymentStatus-Box {
    padding: 10px;
    border: 1px solid black;
    border-radius: 10px;
  }
}
</style>